var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAutoMagic(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.002 7L19.942 4.94L22.002 4L19.942 3.06L19.002 1L18.062 3.06L16.002 4L18.062 4.94L19.002 7Z",
    fill: "#5F6166"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.50195 7L8.44195 4.94L10.502 4L8.44195 3.06L7.50195 1L6.56195 3.06L4.50195 4L6.56195 4.94L7.50195 7Z",
    fill: "#5F6166"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.002 12.5L18.062 14.56L16.002 15.5L18.062 16.44L19.002 18.5L19.942 16.44L22.002 15.5L19.942 14.56L19.002 12.5Z",
    fill: "#5F6166"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7125 9.12L13.8825 6.29C13.6825 6.1 13.4325 6 13.1725 6C12.9125 6 12.6625 6.1 12.4625 6.29L1.2925 17.46C0.9025 17.85 0.9025 18.48 1.2925 18.87L4.1225 21.7C4.3225 21.9 4.5725 22 4.8325 22C5.0925 22 5.3425 21.9 5.5425 21.71L16.7125 10.54C17.1025 10.15 17.1025 9.51 16.7125 9.12ZM13.1725 8.42L14.5825 9.83L13.4125 11L12.0025 9.59L13.1725 8.42ZM4.8325 19.59L3.4225 18.18L10.5925 11L12.0025 12.41L4.8325 19.59Z",
    fill: "#5F6166"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutoMagic);
export default __webpack_public_path__ + "static/media/AutoMagic.ace93984.svg";
export { ForwardRef as ReactComponent };